import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { alertError, parseMemberQRCode } from '../../Util/Util';
import bonusAPI from '../../middleware/bonusAPI';
import {
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { filter, find, forEach, isEmpty, map, parseInt } from 'lodash';
import RoomServiceRoundedIcon from '@material-ui/icons/RoomServiceRounded';
import subscriptionAPI from '../../middleware/subscriptionAPI';
import Swal from 'sweetalert2';
import EventAvailableRoundedIcon from '@material-ui/icons/EventAvailableRounded';
import moment from 'moment';
import Barcode from 'react-barcode';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#fff',
    padding: theme.spacing(2),
  },
  memberInfoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: '0.9rem',
    fontWeight: '500',
  },
  userDailyClaimServices: {
    margin: theme.spacing(1, 0),
    textAlign: 'left',
  },
  userDailyClaimService: {
    backgroundColor: '#eee',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  serviceName: {
    fontSize: '0.9rem',
    fontWeight: '600',
    padding: theme.spacing(0.5),
  },
  serviceDailyList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: theme.spacing(1),
    margin: theme.spacing(1),
  },
  serviceContent: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  serviceItemName: {
    textAlign: 'center',
    width: '120px',
  },
  serviceImg: {
    width: '50px',
    height: '50px',
    objectFit: 'cover',
  },
  barcodeList: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    gap: theme.spacing(1),
    backgroundColor: '#fff',
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1),
  },
  choose: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    fontWeight: 'bold',
    margin: '0',
    fontSize: '0.9rem',
    color: '#b1b1b1',

    '&:before, &:after': {
      content: "' '",
      flex: '1',
      borderBottom: '1px solid #ccc',
      margin: '0 10px',
    },
  },
  claimTime: {
    color: '#999',
    fontWeight: '500',
    fontSize: '0.8rem',
  },
}));

const DailyClaim = (props) => {
  const { qrcode } = props;
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [pageStep, setPageStep] = useState('init');
  const [member, setMember] = useState();
  const [userDailyClaimServices, setUserDailyClaimServices] = useState();
  const [selectedItems, setSelectedItems] = useState({});

  useEffect(() => {
    const qrcodeResult = parseMemberQRCode(qrcode);

    if (qrcodeResult.member) {
      getMember(qrcodeResult.member);
    }
  }, [qrcode]);

  const getMember = (memberQRCode) => {
    return bonusAPI.verifyQrcode(memberQRCode).then(
      (response) => {
        setMember(response);

        if (response.userSubscriptionList) {
          const findDailyClaimServices = filter(
            response.userSubscriptionList,
            (userSubscription) => {
              return userSubscription.dailyClaimAvailable;
            },
          );

          setUserDailyClaimServices(findDailyClaimServices);
        } else {
          setUserDailyClaimServices([]);
        }

        setPageStep('select');
      },
      (error) => {
        alertError(error);
        setPageStep('fail');
      },
    );
  };

  const handleSelectBarcode = (e) => {
    const value = e.target.value;

    if (!value) {
      return false;
    }

    const [userSubscriptId, itemId, type] = value.split('_');

    setSelectedItems((prev) => {
      const userItems = prev[userSubscriptId] || {};

      if (userItems[itemId] === type) {
        const newUserItems = { ...userItems };

        delete newUserItems[itemId];

        const newSelected = { ...prev, [userSubscriptId]: newUserItems };

        if (Object.keys(newUserItems).length === 0) {
          delete newSelected[userSubscriptId];
        }

        return newSelected;
      } else {
        return {
          ...prev,
          [userSubscriptId]: {
            ...userItems,
            [itemId]: type,
          },
        };
      }
    });
  };

  const handleClaim = () => {
    const claimList = [];

    forEach(selectedItems, (selectedItem, userSubscriptId) => {
      forEach(selectedItem, (item, itemId) => {
        claimList.push({
          UserSubscriptionId: userSubscriptId,
          SubscriptionServiceDailyItemId: itemId,
        });
      });
    });

    if (claimList.length > 0) {
      setIsLoading(true);

      subscriptionAPI
        .claimDailyItems(claimList)
        .then(
          (rs) => {
            setPageStep('done');
          },
          (error) => {
            alertError(error);

            const qrcodeResult = parseMemberQRCode(qrcode);
            getMember(qrcodeResult.member);
            setSelectedItems({});
          },
        )
        .then(() => {
          setIsLoading(false);
        });
    } else {
      Swal.fire({
        title: '沒有選擇要領取的品項',
        icon: 'error',
      });
    }
  };

  const getBarcodes = () => {
    let barcodeList = [];

    forEach(selectedItems, (selectedItem, userSubscriptId) => {
      const service = find(
        userDailyClaimServices,
        (userDailyClaimService) =>
          parseInt(userDailyClaimService.userSubscriptionId, 10) ===
          parseInt(userSubscriptId, 10),
      );

      if (service) {
        forEach(selectedItem, (itemType, itemId) => {
          const dailyItem = find(
            service.dailyItemList,
            (dailyItemList) =>
              parseInt(dailyItemList.subscriptionServiceDailyItemId, 10) ===
              parseInt(itemId, 10),
          );

          if (dailyItem) {
            if (itemType === 'one') {
              barcodeList.push({
                barcode: dailyItem.barcodeOne,
                name: dailyItem.barcodeOneName,
              });
            }

            if (itemType === 'two') {
              barcodeList.push({
                barcode: dailyItem.barcodeTwo,
                name: dailyItem.barcodeTwoName,
              });
            }
          }
        });
      }
    });

    return barcodeList;
  };

  return (
    <div className={classes.root}>
      {pageStep === 'init' && (
        <div>
          <CircularProgress />
          <div>讀取中...</div>
        </div>
      )}

      {pageStep === 'select' && (
        <div>
          <h2>每日領取</h2>

          <div>
            <div className={classes.memberInfoRow}>
              <div>會員</div>
              <div>{member.contact}</div>
            </div>
            <div className={classes.memberInfoRow}>
              <div>UserId</div>
              <div>{member.userId}</div>
            </div>
          </div>

          {userDailyClaimServices && userDailyClaimServices.length <= 0 && (
            <div>
              <Alert severity="info">目前沒有每日領取的服務</Alert>
            </div>
          )}

          {userDailyClaimServices && userDailyClaimServices.length > 0 && (
            <div className={classes.userDailyClaimServices}>
              {map(userDailyClaimServices, (userDailyClaimService) => {
                return (
                  <div
                    key={userDailyClaimService.id}
                    className={classes.userDailyClaimService}>
                    <div className={classes.serviceName}>
                      {userDailyClaimService.serviceName}
                    </div>

                    <div className={classes.serviceDailyList}>
                      {map(userDailyClaimService.dailyItemList, (dailyItem) => {
                        const { isClaimable, claimDate } = dailyItem;
                        const userItems =
                          selectedItems[
                            userDailyClaimService.userSubscriptionId
                          ] || {};
                        const isOneChecked =
                          userItems[
                            dailyItem.subscriptionServiceDailyItemId
                          ] === 'one';
                        const isTwoChecked =
                          userItems[
                            dailyItem.subscriptionServiceDailyItemId
                          ] === 'two';

                        return (
                          <div
                            key={dailyItem.subscriptionServiceDailyItemId}
                            className={classes.serviceContent}>
                            <div className={classes.serviceItemName}>
                              <img
                                className={classes.serviceImg}
                                src={userDailyClaimService.imageUrl}
                              />
                              <div>{dailyItem.itemName}</div>
                            </div>

                            <div className={classes.barcodeList}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    color="primary"
                                    icon={
                                      !isClaimable ? (
                                        <EventAvailableRoundedIcon fontSize="small" />
                                      ) : (
                                        undefined
                                      )
                                    }
                                    checkedIcon={
                                      !isClaimable ? (
                                        <EventAvailableRoundedIcon fontSize="small" />
                                      ) : (
                                        undefined
                                      )
                                    }
                                  />
                                }
                                label={dailyItem.barcodeOneName}
                                value={`${userDailyClaimService.userSubscriptionId}_${dailyItem.subscriptionServiceDailyItemId}_one`}
                                onClick={handleSelectBarcode}
                                checked={isOneChecked}
                                disabled={isLoading || !isClaimable}
                              />

                              {dailyItem.barcodeTwo && (
                                <>
                                  <div className={classes.choose}>或</div>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        color="primary"
                                        icon={
                                          !isClaimable ? (
                                            <EventAvailableRoundedIcon fontSize="small" />
                                          ) : (
                                            undefined
                                          )
                                        }
                                        checkedIcon={
                                          !isClaimable ? (
                                            <EventAvailableRoundedIcon fontSize="small" />
                                          ) : (
                                            undefined
                                          )
                                        }
                                      />
                                    }
                                    label={dailyItem.barcodeTwoName}
                                    value={`${userDailyClaimService.userSubscriptionId}_${dailyItem.subscriptionServiceDailyItemId}_two`}
                                    onClick={handleSelectBarcode}
                                    checked={isTwoChecked}
                                    disabled={isLoading || !isClaimable}
                                  />
                                </>
                              )}

                              {!isClaimable && (
                                <div className={classes.claimTime}>
                                  領取時間 {moment(claimDate).format('HH:mm')}
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}

              <Button
                variant="contained"
                color="primary"
                fullWidth
                disabled={isLoading || isEmpty(selectedItems)}
                startIcon={<RoomServiceRoundedIcon />}
                onClick={handleClaim}>
                領取並顯示 Barcode
              </Button>
            </div>
          )}
        </div>
      )}

      {pageStep === 'done' && (
        <>
          <Alert severity="success">
            領取完成，請掃描 Barcode 完成 POS 機操作後，即可按回首頁結束流程。
          </Alert>
          <div>
            {map(getBarcodes(), (barcode, index) => {
              return (
                <div key={index}>
                  <Barcode
                    height={30}
                    fontSize={16}
                    value={barcode.barcode}
                    width={1}
                  />
                  <div>{barcode.name}</div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default DailyClaim;
